module.exports = __webpack_public_path__ + "static/media/inceleme_videosu_ADIM3.b92a3480.jpg";